import { Environment } from '@/environments/environment.interface';
import { InjectionToken } from '@angular/core';

export const ENVIRONMENT = new InjectionToken<Environment>('Application environment');